var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-pagination',{attrs:{"current-page":_vm.current,"page-size":_vm.size,"pager-count":5,"total":_vm.total,"background":""},on:{"size-change":_vm.sizeChange,"current-change":_vm.handleCurrent,"next-click":_vm.handleCurrent,"prev-click":_vm.handleCurrent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }